export type BadgeDisplayUnit = "mm" | "in"

export const MM_PER_INCH = 25.4

export const convertMmToUnit = (valueMm: number, unit: BadgeDisplayUnit): number => {
  if (unit === "in") {
    return valueMm / MM_PER_INCH
  }

  return valueMm
}

export const convertUnitToMm = (value: number, unit: BadgeDisplayUnit): number => {
  if (unit === "in") {
    return value * MM_PER_INCH
  }

  return value
}

export const formatMeasurement = (
  valueMm: number,
  unit: BadgeDisplayUnit,
  options?: { precision?: number },
): string => {
  const { precision = unit === "in" ? 2 : 0 } = options || {}
  const converted = convertMmToUnit(valueMm, unit)

  return `${converted.toFixed(precision)}${unit === "in" ? "″" : "mm"}`
}
